import { CodeParams } from "@/types/codeTypes";

export class Code {
  id: string;
  readonly createdAt: Date | string;
  readonly updatedAt: Date | string;
  script: string;
  operationId: string;
  lastRanAt?: Date;
  stdout: string;
  stderr: string;
  returnCode: number;
  propelOrgId: string;

  constructor(params: CodeParams) {
    this.id = params.id;
    this.createdAt = params.createdAt;
    this.updatedAt = params.updatedAt;
    this.script = params.script || '';
    this.operationId = params.operationId;
    this.lastRanAt = params.lastRanAt;
    this.stdout = params.stdout || '';
    this.stderr = params.stderr || '';
    this.returnCode = params.returnCode || 0;
    this.propelOrgId = params.propelOrgId || '';
  }
}
